import { useEffect } from "react";
import { useLocation } from "react-router-dom";

function ScrollToHash() {
  const location = useLocation();
  const { hash, key } = location;

  useEffect(() => {
    if (!hash) return;

    let attempts = 0;

    const scroll = () => {
      const el = document.querySelector(hash);
      if (el) {
        el.scrollIntoView({ behavior: "smooth", block: "start" });
        return true;
      }
      return false;
    };

    // Try immediately
    if (scroll()) return;

    // Retry if element not mounted yet
    const interval = setInterval(() => {
      attempts++;
      if (scroll() || attempts > 20) {
        clearInterval(interval);
      }
    }, 100);

    return () => clearInterval(interval);
  }, [hash, key]); // 👈 key forces re-run even if hash is same

  return null;
}

export default ScrollToHash;
